import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@context/AuthProvider";
import { SYSTEM_MENU_RM, type SystemMenuResponse } from "@/routes/systemMenu";

// Request 116 direto no session (não passa por UseCaseManager/openUseCase — é mensagem de sessão,
// não de UC de tela). Árvore de menu não muda durante a sessão — staleTime Infinity, sem refetch
// automático. Ver src/routes/systemMenu.ts pro contrato completo.
export const useSystemMenu = () => {
  const { session, isAuth } = useAuth();

  return useQuery<SystemMenuResponse>({
    queryKey: ["system", "menu"],
    // sendRequest da UseCase base não é genérico (Promise<any>) — cast explícito aqui.
    // level 1 aplica o novo arquivo xml dado que nosso sinal de sistema eh 61 e nao 19 (ver C:\git\curio-framework\server\app\ucu\ucuMain.pas)
    queryFn: () => session!.sendRequest(SYSTEM_MENU_RM, { Level: 1, Version: 3 }) as Promise<SystemMenuResponse>,
    enabled: isAuth && !!session,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 1
  });
};
